<template>
  <div class="top">
      <div class="bg-white" style="padding: 10px 0 0 30px" v-if="+detailObj.orders.orderStatusSub === 1">
        <p style="color: #eb5757; font-size: 18px; font-weight: 600">Refund failed</p>
        <p style="font-weight: 400; font-size: 14px; line-height: 21px; color: #000000">{{ detailObj.orders.auditReason }}</p>
      </div>
      <div class="f" v-if="showStatus === 'waiting_payment'">
        <div class="status bg-white f-c-c fd-c" v-cloak>
          <div>Waiting payment</div>
        </div>
        <div class="process bg-white">
          <div class="explain" v-cloak>
            <template v-if="platformCode !== 'KA'">
              <span class="inline-block">Your order hasn’t paid yet. Click ”Pay Now” to continue. </span>
            </template>
            <template v-if="countDownTime < 0">
              <i class="el-icon-time inline-block" style="margin-right: 4px"></i>
              <span class="inline-block" style="margin-right: 4px">Remaining:</span>
              <span class="inline-block" style="color: red; margin-right: 4px">{{ countDownTime | getHHmmss }}</span>
              <span style="margin-right: 4px">Your order hasn’t paid yet. Click ”Pay Now” to continue. </span>
            </template>
          </div>
          <el-timeline class="myTimeLine" v-cloak>
            <timeLineItem :timestamp="moment(detailObj.times.purchaseDate).format('YYYY-MM-DD HH:mm:ss')" type="success">Order Submitted</timeLineItem>
            <timeLineItem :timestamp="undefined">Order Confirmed</timeLineItem>
            <timeLineItem :timestamp="undefined">Shipped</timeLineItem>
            <timeLineItem :timestamp="undefined">Order Complete</timeLineItem>
          </el-timeline>
        </div>
      </div>
      <div class="f" v-if="showStatus === 'waiting_to_ship'">
        <div class="status bg-white f-c-c fd-c" v-cloak>
          <div>Waiting to Ship</div>
        </div>
        <div class="process bg-white">
          <div class="explain" v-cloak>
            <span class="inline-block">Every single product goes through our rigorous quality inspection before we send it to your customers.</span>
          </div>
          <el-timeline class="myTimeLine" v-cloak>
            <timeLineItem :timestamp="moment(detailObj.times.purchaseDate).format('YYYY-MM-DD HH:mm:ss')" type="success">Order Submitted</timeLineItem>
            <timeLineItem :timestamp="moment(detailObj.times.payDate).format('YYYY-MM-DD HH:mm:ss')" type="success">Order Confirmed</timeLineItem>
            <timeLineItem :timestamp="undefined">Shipped</timeLineItem>
            <timeLineItem :timestamp="undefined">Order Complete</timeLineItem>
          </el-timeline>
        </div>
      </div>
      <div class="f" v-if="showStatus === 'partial_shipped'">
        <div class="status bg-white f-c-c" v-cloak>
          <div>Partial Shipped</div>
        </div>
        <div class="process bg-white">
          <div class="explain" v-cloak>
            <span class="inline-block">Some products have not yet shipped，We’ll let you know once it has shipped</span>
          </div>
          <el-timeline class="myTimeLine" v-cloak>
            <timeLineItem :timestamp="moment(detailObj.times.purchaseDate).format('YYYY-MM-DD HH:mm:ss')" type="success">Order Submitted</timeLineItem>
            <timeLineItem :timestamp="moment(detailObj.times.payDate).format('YYYY-MM-DD HH:mm:ss')" type="success">Order Confirmed</timeLineItem>
            <timeLineItem :timestamp="moment(detailObj.times.deliveryDate).format('YYYY-MM-DD HH:mm:ss')" type="success">Shipped</timeLineItem>
            <timeLineItem :timestamp="undefined">Order Complete</timeLineItem>
          </el-timeline>
        </div>
      </div>
      <div class="f" v-if="showStatus === 'fully_shipped'">
        <div class="status bg-white f-c-c" v-cloak>
          <div>Fully Shipped</div>
        </div>
        <div class="process bg-white">
          <div class="explain" v-cloak>
            <span class="inline-block">You order is on its way !</span>
          </div>
          <el-timeline class="myTimeLine" v-cloak>
            <timeLineItem :timestamp="moment(detailObj.times.purchaseDate).format('YYYY-MM-DD HH:mm:ss')" type="success">Order Submitted</timeLineItem>
            <timeLineItem :timestamp="moment(detailObj.times.payDate).format('YYYY-MM-DD HH:mm:ss')" type="success">Order Confirmed</timeLineItem>
            <timeLineItem :timestamp="moment(detailObj.times.deliveryDate).format('YYYY-MM-DD HH:mm:ss')" type="success">Shipped</timeLineItem>
            <timeLineItem :timestamp="undefined">Order Complete</timeLineItem>
          </el-timeline>
        </div>
      </div>
      <div class="f" v-if="showStatus === 'completed'">
        <div class="status bg-white f-c-c" v-cloak>
          <div>Completed</div>
        </div>
        <div class="process bg-white">
          <div class="explain" v-cloak>
            <span class="inline-block">Your goods are shipped out of the warehouse and are in transit</span>
          </div>
          <el-timeline class="myTimeLine" v-cloak>
            <timeLineItem :timestamp="moment(detailObj.times.purchaseDate).format('YYYY-MM-DD HH:mm:ss')" type="success">Order Submitted</timeLineItem>
            <timeLineItem :timestamp="moment(detailObj.times.payDate).format('YYYY-MM-DD HH:mm:ss')" type="success">Order Confirmed</timeLineItem>
            <timeLineItem :timestamp="moment(detailObj.times.deliveryDate).format('YYYY-MM-DD HH:mm:ss')" type="success">Shipping</timeLineItem>
            <timeLineItem :timestamp="moment(detailObj.times.completedDate).format('YYYY-MM-DD HH:mm:ss')" type="success">Order Complete</timeLineItem>
          </el-timeline>
        </div>
      </div>
      <div class="f" v-if="showStatus === 'cancel'">
        <div class="status bg-white f-c-c" v-cloak>
          <div>Cancel</div>
        </div>
        <div class="process bg-white">
          <div class="explain" v-cloak>
            <span class="inline-block">Your order has been cancelled successfully</span>
          </div>
          <el-timeline class="myTimeLine" v-cloak>
            <timeLineItem :timestamp="moment(detailObj.times.purchaseDate).format('YYYY-MM-DD HH:mm:ss')" type="success">Order Submitted</timeLineItem>
            <timeLineItem :timestamp="moment(detailObj.times.cancelDate).format('YYYY-MM-DD HH:mm:ss')" type="success">Cancel</timeLineItem>
            <timeLineItem :timestamp="undefined" type="success">Finish</timeLineItem>
          </el-timeline>
        </div>
      </div>
      <div class="f" v-if="detailObj.orders.status === 'abnormal_order'">
        <div class="status bg-white f-c-c fd-c" v-cloak>
          <div>Abnormal Order</div>
        </div>
        <div class="process bg-white">
          <div class="explain" v-if="detailObj.orders.notes">
            <h4 class="inline-block">{{ detailObj.orders.notes.code === 1 || !detailObj.orders.notes.code  ? 'Incomplete recipient information' : 'Failed to abtain logistics' }}</h4>
          </div>
          <div v-if="detailObj.orders.notes">{{ detailObj.orders.notes.value }}</div>
        </div>
      </div>
    </div>
</template>

<script>
import timeLineItem from '@/components/timeLineItem.vue'
import moment from 'moment'
export default {
props: {
  detailObj: {
    type: Object,
    default: () => ({
      'times': {
        'purchaseDate': 1670320180000,
        'payDate': 1670320200000,
        'completedDate': 2021,
        'cancelDate': 1,
        'refundDate': 1,
        'deliveryDate': 1670720180000
      },
      'address': {
        'country': 'CH',
        'city': '深圳',
        'phone': '137562586632',
        'recipient': '铁头男孩',
        'street1': '街道一',
        'street2': '街道二',
        'province': '湖南省',
        'zip': '邮编',
        'vat': 'ssssaca',
        'ioss': ''
      },
      'orders': {
        'storeOrderId': 'xdczxczxc',
        'kkOrderId': 'xzczxczxcvzxnkNx',
        'platformCode': 'AM',
        'remark': '我不要这个订单的',
        'refundStatus': 'XSS',
        'fulfillmentStatus': 'fully_shipped',
        'financialStatus': 'waiting',
        'channelCode': '',
        'platformName': '',
        'storeName': '',
        'email': '',
        'refundReason': '',
        'status': 'cancel'
      },
      'pays': {
        'finalAmount': 100,
        'freightAmount': 1000,
        'skusAmount': 10000,
        'paymentMethod': 'paypay',
        'couponAmount': 1,
        'paymentId': '',
        'discountAmount': ''
      },
      'orderLogistics': [
        {
          'omsPackId': '',
          'deliveryDate': 137562586632,
          'trackingCode': '1ssdvsdv',
          'packStatus': 'Preparing',
          'logisticsProviders': '小四快递',
          'weightSum': '',
          'items': [
            {
              'refundStatus': 'XSS',
              'fulfillmentStatus': 'fulfillmentStatusName',
              'financialStatus': '',
              'imageUrl': 'LKNASKONCOASNCLKNAS',
              'productName': 'NC 女士缎面真丝睡衣..',
              'productNum': 2,
              'skuCode': 'AMB00393',
              'sellerSku': 'AMB00393',
              'options': 'red',
              'price': 50,
              'finalAmount': 1,
              'isOutOfStock': 1,
              'subtotal': ''
            }
          ]
        }
      ]
    })
  }
},
components: {
  timeLineItem
},
filters: {
  getHHmmss(value) {
    let day = Math.floor(value / (1000 * 60 * 60 * 24))
    let hours = Math.floor((value / (1000 * 60 * 60)) % 24).toString()
    let minute = Math.floor((value / (1000 * 60)) % 60).toString()
    let second = Math.floor((value / 1000) % 60).toString()
    if (hours.length === 1) hours = `0${hours}`
    if (minute.length === 1) minute = `0${minute}`
    if (second.length === 1) second = `0${second}`
    if (day > 0) {
      return `${day} days ${hours}:${minute}:${second}`
    }
    return `${hours}:${minute}:${second}`
  }
},
computed: {
  showStatus() {
    if (['waiting_payment', 'completed', 'cancel'].includes(this.detailObj.orders.status)) return this.detailObj.orders.status
    if (this.detailObj.orders.status === 'abnormal_order') return this.detailObj.orders.financialStatus
    if (this.detailObj.orders.status === 'processing') return this.detailObj.orders.fulfillmentStatus
    return 'NULL'
    /*
      waiting_payment 待支付
      completed 已完成
      cancel 已取消
      waiting_to_ship 待发货
      fully_shipped 已发货
      partial_shipped  部分发货
    */
  },
  platformCode() {
    if (this.detailObj.orders.platformCode) return this.detailObj.orders.platformCode
    return 'KA'
  },
  countDownTime() {
    let startTime = this.detailObj.times.purchaseDate
    let endTime = startTime + 1000 * 60 * 60 * 24 * 5
    return endTime - this.currentTime - 3000
  }
},
data() {
  return {
    remainingTime: 1670320080000, // 下单时间，做倒计时
    Interval: null,
    currentTime: moment().valueOf(),
    moment
  }
},
created() {
  // console.log(this.detailObj)
},
mounted() {
  if (this.showStatus === 'waiting_payment') {
    const that = this
    this.Interval = setInterval(() => {
      that.currentTime = new Date().valueOf()
      if (that.currentTime < 0) {
        that.detailObj.orders.status = 'cancel'
        clearInterval(that.Interval)
      }
    }, 1000)
  }
},
methods: {
  payNowClick() {
    const { productName, productNum, skuCode: productSku } = this.detailObj.orderLogistics[0].items[0]
    const product = {
      kkOrderIds: [this.detailObj.orders.kkOrderId],
      totalAmount: this.detailObj.pays.finalAmount,
      platformCode: this.detailObj.orders.platformCode,
      productName,
      productNum,
      productSku,
      orderItems: this.detailObj.orderLogistics[0].items
    }
    localStorage.setItem('product.kkOrderId', this.detailObj.orders.kkOrderId)
    if (this.isPC) {
      this.$refs.payDialog.show(product)
    } else {
      this.$refs.payDialog.MTShow(product)
    }
  }

}
}
</script>

<style lang="scss" scoped>
.top {
  margin-bottom: 14px;
  .status {
    height: 146px;
    margin-right: 2px;
    // padding-left: 30px;
    width: 300px;
    > div:first-of-type {
      font-size: 18px;
      font-weight: bold;
    }
  }
  .process {
    height: 146px;
    flex: 1;
    padding: 20px 0 20px 40px;
    .myTimeLine {
      display: flex;
    }
    .explain {
      height: 24px;
      line-height: 24px;
      font-size: 14px;
      margin-bottom: 24px;
    }
  }
}
</style>
